import { FunctionComponent } from 'react';
import { PLATFORM_LEGAL_CORPORATION_LABEL } from 'services/api/constants';
import { useIntlByKey } from 'services/i18n/hooks/useIntlByKey';

// React 19 hoists <title> and <meta> rendered anywhere in the tree into document.head
export const AppHelmet: FunctionComponent = () => {
  const appHelmetIntl = useIntlByKey('app.helmet');

  return (
    <>
      <title>
        {appHelmetIntl('title', { legalCorporationLabel: PLATFORM_LEGAL_CORPORATION_LABEL })}
      </title>
      <meta
        name="description"
        content={appHelmetIntl('description', {
          legalCorporationLabel: PLATFORM_LEGAL_CORPORATION_LABEL,
        })}
      />
    </>
  );
};
